import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          maxHeight="667px"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          alignCenter
        >
          <Header />
          <CFView textCenter w="100%">
            <CFView mt="22px">
              <CFText h1 black raleway xBold>
                Welcome to Yale Sushi Chilliwack
              </CFText>
            </CFView>
            <CFView mt="25px" pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView>
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="135px" h="700px">
            <CFView column justifyCenter alignStart>
              <CFImage
                w="534px"
                h="127px"
                src={heroText}
                alt="Yale sushi hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mt="30px" pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView>
              <OrderDeliveryButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
